import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  tenantApplication: generateApiPath({ prefix: AuthLevel.JWT_AUTH, name: 'tenant-application' }),
}

export { paths }
